<template>
	<div :class="[(slider&&card  ? 'product-card w-full hvr-grow' : ''), (!slider&&card ? `product-card p-3 hvr-grow  w-full ${cardWidth}` : '')]">
		
		<div v-if="card">
			<a class="block" :href="product.route">
				<div class="relative max-w-sm mx-auto overflow-hidden bg-white">
					<div class="relative block product-img">
						<img class="image" :data-src="product.image ? product.image : '/front/img/dummy_data/2.jpeg'" :alt="product.name">
					</div>
					<div class="details">
						<div class="text-center title text-primary">
							{{product.name}}
						</div>
						<div class="text-center price">
							<template>
								<p class="w-full current">{{ product.price +' '+ t('sar_half') }}</p>
							</template>
						</div>
					</div>
				</div>
			</a>
		</div>

		<div  v-else>
			<div class="mt-2 text-xs lg:text-base">
				<span class="font-bold text-black">{{ product.price}}<span>{{t('sar_half')}}</span></span>
				<p class="text-xs text-secondary-200">السعر شامل الضريبة</p>
			</div>
			
			<div v-if="product.sizes" class="flex py-4 mt-4 border-t border-primary-100">
				<div v-for="(size , index) in product.sizes" class="ml-2 leading-8 border border-primary min-w-16">
					<div class="product-radio "> 
						<input type="radio" name="product_size" :id="'size'+index" :value="size" v-model="product_size">
						<label class="text-center radio payment-radio custom ">
							<h3 class="px-3" >{{  size }}</h3>
						</label>
					</div>
				</div>
			</div>
      <div v-if="product.colors" class="flex py-4 mt-4 border-t border-primary-100">
        <div v-for="(color , index) in product.colors" class="w-16 ml-2 leading-8 border border-primary">
          <div class="product-radio">
            <input type="radio" name="product_color" :id="'color'+index" :value="color" v-model="product_color">
            <label class="text-center radio payment-radio custom">
              <h3>{{ color }}</h3>
            </label>
          </div>
        </div>
      </div>
			<div v-if="product.active" class="mt-4 text-xs lg:text-base">
				<button class="text-white button bg-secondary-200 hover:bg-primary focus:outline-none " @click.prevent="addToCart(product.id , product_color, product_size)"   type="submit"><i class="icon icon-shopping-bag"></i> {{ t('add_to_cart') }}</button>
			</div>
			<div v-else class="mt-2">
				<p class="text-sm text-red-600 has-text-weight-bold lg:text-lg">{{t('unavailable_product')}}</p>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "ProductCard",
	props: {
		sitelocale:{
			type: String,
			required: true
		},
		auth:{
			required: true,
			type: String,
		},
		product:{
			required:true,
			type:Object
		},
    store:{
      required: true,
      type: String,
    },
		favRoute:{
			required: true,
			type: String,
		},
		isFav:{
			required: true,
			type: String,
		},
		slider:{
			type: Boolean,
			default:true
		},
		card:{
			type: Boolean,
			default:true
		},
		cardWidth:{
			type:String,
			default:'sm:w-1/2 md:w-4/12 lg:w-4/12'
		},

	},
	data() {
		return {
      product_color:null,
      product_size:null,
		};
	},
	mounted() {
		this.$translate.setLang(this.sitelocale);
	},
	created() {
		//
	},
	methods: {
		addToCart(productId , product_color, product_size) {
      if (!this.auth) {
        let toaster = this.$toasted;
        toaster.error('يرجي  تسجيل الدخول');
        setTimeout(()=>{
          window.location = `/login/`
        }, 1000)
      } else {
        if ((this.product.colors && !product_color) && (this.product.sizes && !product_size)) {
          let toaster = this.$toasted;
          toaster.error('يرجي اختيار اللون والمقاس');
        } else if ((this.product.colors && !product_color)) {
          let toaster = this.$toasted;
          toaster.error('يرجي اختيار اللون');
        } else if ((this.product.sizes && !product_size)) {
          let toaster = this.$toasted;
          toaster.error('يرجي اختيار المقاس');
        } else {
          axios.post(this.store, {product_id : productId, product_color : product_color, product_size:product_size}).then(({data}) => {
            let toaster = this.$toasted;
            toaster.success(data.message);
            $('.cart-counter').text(data.items.length);
            $('.cart-counter').addClass('shake-animation').delay(1000).queue(function (next) {
              $(this).removeClass('shake-animation');
              next();
            });
          }).catch(errors => {
            let toaster = this.$toasted;
            toaster.error(errors.response.data.message);
          });
        }
      }
		}
	}
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/Product/ProductCard.vue